/**
 * Tender Data Mapping Utilities
 * Handles inconsistencies between backend request/response field names
 */

import type { TenderResponseDto } from '@/types/tender'

/**
 * Normalize tender response from backend to ensure all fields are properly mapped
 * Backend inconsistency: 
 * - GET responses use: reference, location, submissionDeadline
 * - POST/PUT requests expect: closingDate, projectLocation
 */
export function normalizeTenderResponse(tender: any): TenderResponseDto {
  return {
    ...tender,
    // Ensure referenceNumber exists (backend sends 'reference')
    referenceNumber: tender.referenceNumber || tender.reference,
    reference: tender.reference || tender.referenceNumber,
    
    // Ensure both field names are available for location
    location: tender.location || tender.projectLocation,
    projectLocation: tender.projectLocation || tender.location,
    
    // Ensure both field names are available for deadline
    submissionDeadline: tender.submissionDeadline || tender.closingDate,
    closingDate: tender.closingDate || tender.submissionDeadline,
    
    // Ensure organization name is available
    organizationName: tender.organizationName || tender.issuingOrganization,
    issuingOrganization: tender.issuingOrganization || tender.organizationName,
    
    // Ensure application count exists (default to 0 if not present)
    applicationCount: tender.applicationCount ?? 0,
  } as TenderResponseDto
}

/**
 * Normalize an array of tender responses
 */
export function normalizeTenderList(tenders: any[]): TenderResponseDto[] {
  return tenders.map(normalizeTenderResponse)
}
